module.exports = __webpack_public_path__ + "img/iPad Pro 12.9 - 3.8c3242c6.jpg";